<template>
  <div
    class="app-wrapper sidebar-container left_content"
    :class="{ bgw: !theme, wd5: collapsed }"
  >
    <div class="slider_title" :class="{ colorbgw: !theme }">
      <!-- <img :src="!theme ? logo : logo_light" class="logo" @click="toHome" /> -->
    </div>
    <a-menu
      @openChange="onOpenChange"
      :selectedKeys="selectKey"
      v-model:openKeys="openKey"
      mode="inline"
      :theme="theme ? 'dark' : 'light'"
      ref="menu"
    >
      <template v-for="item in permissionsMenu">
        <a-sub-menu :key="item.name" v-if="!item.hidden">
          <!-- 菜单项 -->
          <template v-slot:title>
            <icon-font :type="item.meta.icon" />
            <span>{{ item.meta.title }}</span>
          </template>
          <a-menu-item-group key="aaa">
            <template v-slot:title>{{ item.meta.title }}</template>
            <template v-for="data in item.children">
              <!-- 子菜单项 -->
              <a-menu-item
                v-if="!data.hidden"
                @click="click(data.name)"
                :key="data.name"
                style="
                  color: #657180;
                  text-align: center;
                  border-bottom: 1px solid #ccc;
                "
              >
                <icon-font :type="data.meta.icon" />
                <span :class="{ set: data.meta.title.length === 3 }">{{
                  data.meta.title
                }}</span>
              </a-menu-item>
            </template>
          </a-menu-item-group>
        </a-sub-menu>
      </template>
    </a-menu>
  </div>
</template>

<script>
import menuApi from "@axios/sys/menu";
import logo from "@assets/logo.png";
import logo_light from "@assets/logo.png";
import { useRoute, useRouter, onBeforeRouteUpdate } from "vue-router";
import { onMounted, ref, watch, watchEffect } from "vue";
import { routerArr } from "../../../router/index";
import { createFromIconfontCN } from "@ant-design/icons-vue";

const IconFont = createFromIconfontCN({
  scriptUrl: "//at.alicdn.com/t/font_2033419_extitw862n.js",
});
export default {
  name: "left",
  components: {
    IconFont,
  },
  props: {
    theme: {
      type: Boolean,
      default: true,
    },
    parentId: {
      type: Number,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
    changeMenu: {
      type: Number,
    },
  },
  setup(props, context) {
    let isActive = ref(false);
    const route = useRoute();
    const router = useRouter();
    let selectKey = ref([1]);
    let openKey = ref([]);
    let permissionsMenu = ref([]);
    const { currentRoute } = useRouter();
    openKey.value = [currentRoute.value.matched[0].name];

    selectKey.value = [currentRoute.value.name];
    //permissionsMenu = routerArr;

    //查询菜单列表
    const findRouters = () => {
      let params = { parentId: props.parentId };
      menuApi.findRouters(params).then((res) => {
        if (!res) return;
        permissionsMenu.value = res;
        // res.forEach((item,index) => {
        //   console.log(item.name)
        //   if(item.meta.title==='供应管理'){
        //     item.children.push({
        //       name:'addSupply',
        //       component:'addSupply',
        //       hidden:false,
        //       path: "shopIndex",
        //       meta:{title:'添加供应',icon:"iconliebiao",noCache:false},
        //       redirect:''
        //     })
        //   }
        // });
      });
    };

    findRouters();

    watchEffect(() => {
      findRouters();
    });
    if (route.path === "/home/index") {
      openKey.value = ["shop"];
    }
    // if (props.changeMenu == 1) {
    //   openKey.value = ["shop"];
    // }
    // if (props.changeMenu == 3) {
    //   openKey.value = ["sys"];
    // }

    // if (route.path == "/order/scoreQuery") {
    //   openKey.value = ["sys"];
    // }
    //  if (route.path == "/shop/index") {
    //   openKey.value = ["shop"];
    // }
    // watch(
    //   () => route.path,
    //   (newVal, oldVal) => {
    //     if (route.path === "/home/index") {
    //       openKey.value = ["shop"];
    //     }
    //     if (route.path == "/order/scoreQuery") {
    //       openKey.value = ["sys"];
    //     }
    //   }
    // );
    const onOpenChange = (val) => {
      openKey.val = [];
      console.log(val);
      if (val.length === 0) {
        context.emit("flag", true);
      } else {
        context.emit("flag", false);
      }
      if (openKey.value.length == 1) {
        return;
      } else {
        openKey.value = val;
        openKey.value.shift();
      }
      if (changeMenu == 3) {
        openKey.val = [];
      }
    };
    const toHome = () => {
      if ("homeIndex" == route.name) {
        return;
      }
      selectKey.value = [];
      openKey.value = [];
      router.replace({
        name: "homeIndex",
      });
    };

    const getPath = () => {
      selectKey.value = [route.name];
      openKey.value = [route.matched[0].name];
    };

    const click = (name) => {
      selectKey.value = [name];
      if (name == route.name) {
        return;
      }
      router.replace({
        name: name,
      });
    };
    return {
      isActive,
      logo,
      logo_light,
      selectKey,
      openKey,
      permissionsMenu,
      onOpenChange,
      toHome,
      getPath,
      click,
      findRouters,
    };
  },
  watch: {
    $route: "getPath",
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.set {
  letter-spacing: 3.36px;
}
// .ant-menu-item:nth-child(4) {
//   letter-spacing: 3.36px;
// }
.app-wrapper {
  background: #333333 !important;
  min-width: 138px;
  min-height: 100% !important;
}
.slider_title {
  height: 50px;
  font-size: 30px;
  color: #fff;
  line-height: 50px;
  overflow: hidden;
}

.wd5 {
  width: 80px !important;
}

.bgw {
  background: #fff !important;
  // border-right:2px solid #eee;
}

.colorbgw {
  color: #001529;
}

.logo {
  width: 60px;
}
/deep/ .ant-menu-item-group-title {
  color: #464c5b !important;
  border-bottom: 1px solid #ccc;
  height: 50px;
  padding: 16px;
}
</style>
<style scoped>
.icons-list >>> .anticon {
  margin-right: 6px;
  font-size: 24px;
}
</style>
